import React from "react";
import { SectionTabs, type SectionTab } from "@cms/ui/components/section-tabs";

const SETTINGS_TABS: SectionTab[] = [
  { label: "General", href: "/settings", end: true },
  { label: "Opening Hours", href: "/settings/hours", end: true },
];

/** The Settings section's sticky tab header; `action` renders right-aligned. */
export function SettingsTabs({ action }: { action?: React.ReactNode }) {
  return <SectionTabs sticky items={SETTINGS_TABS} action={action} />;
}
